/**
 * @author Matěj Grabovský <matej.grabovsky@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

import template from './setup-header.html';

export default {
  name: 'SetupHeader',
  template,
  methods: {
    onBack() {
      this.$emit('back');
    }
  },
  props: ['isOnline', 'title']
};
